// firebaseConfig.ts

import type { FirebaseOptions } from 'firebase/app';

import { WebAppEnvironment } from '@/types/api';

export type FirebaseDynamicLinkInfo = {
  domainUriPrefix: string;
  iosBundleId: string;
  iosAppStoreId: string;
  androidPackageName: string;
};

export type FirebaseConfig = {
  functionsBaseUrl: string;
  dynamicLinkInfo: FirebaseDynamicLinkInfo;
} & FirebaseOptions;

export const firebaseConfigs: Record<WebAppEnvironment, FirebaseConfig> = {
  [WebAppEnvironment.STAGING]: {
    apiKey: 'AIzaSyB1qp55NlhPP55hABigT2Gk_z6WTxPtp74',
    authDomain: 'soundreply-coach-poc-staging.firebaseapp.com',
    projectId: 'soundreply-coach-poc-staging',
    storageBucket: 'soundreply-coach-poc-staging.appspot.com',
    messagingSenderId: '645392519698',
    appId: '1:645392519698:web:abcdef123456',
    databaseURL: 'https://soundreply-coach-poc-staging.firebaseio.com',
    functionsBaseUrl:
      'https://us-central1-soundreply-coach-poc-staging.cloudfunctions.net',
    dynamicLinkInfo: {
      domainUriPrefix: 'https://soundreplycoachpocstaging.page.link',
      iosBundleId: 'fm.how.training.develop',
      iosAppStoreId: '',
      androidPackageName: 'fm.how.app.develop',
    },
  },
  [WebAppEnvironment.PRODUCTION]: {
    apiKey: 'AIzaSyAM-5_pnuzksb3wTjS7H0DQApI3zFqf_OE',
    authDomain: 'my.how.fm',
    projectId: 'how-fm-production-eu',
    storageBucket: 'how-fm-production-eu.appspot.com',
    messagingSenderId: '667304076153',
    appId: '1:667304076153:web:abcdef789012',
    databaseURL: 'https://how-fm-production-eu.firebaseio.com',
    functionsBaseUrl:
      'https://us-central1-how-fm-production-eu.cloudfunctions.net',
    dynamicLinkInfo: {
      domainUriPrefix: 'https://appeu.how.fm/links',
      iosBundleId: 'fm.how.app',
      iosAppStoreId: '1455471478',
      androidPackageName: 'fm.how.app',
    },
  },
  [WebAppEnvironment.SAMWISE]: {
    apiKey: 'AIzaSyAC9FvxUvpyV6ymJB5vCyPevrbIHkXxov4',
    authDomain: 'soundreply-coach-ms.firebaseapp.com',
    projectId: 'soundreply-coach-ms',
    storageBucket: 'soundreply-coach-ms.appspot.com',
    messagingSenderId: '861898654121',
    appId: '1:861898654121:web:abcdef345678',
    databaseURL: 'https://soundreply-coach-ms.firebaseio.com',
    functionsBaseUrl:
      'https://us-central1-soundreply-coach-ms.cloudfunctions.net',
    dynamicLinkInfo: {
      domainUriPrefix: 'https://howfmsamwise.page.link',
      iosBundleId: 'com.soundreply.soundreply.develop',
      iosAppStoreId: '',
      androidPackageName: 'fm.how.app.develop',
    },
  },
  [WebAppEnvironment.FRODO]: {
    apiKey: 'AIzaSyAxWNcTfFFwcY3OqAsV9JFURwTK9Nf_-JE',
    authDomain: 'howfm-frodo.firebaseapp.com',
    projectId: 'howfm-frodo',
    storageBucket: 'howfm-frodo.appspot.com',
    messagingSenderId: '996090491568',
    appId: '1:996090491568:web:abcdef567890',
    databaseURL: 'https://howfm-frodo.firebaseio.com',
    functionsBaseUrl: 'https://us-central1-howfm-frodo.cloudfunctions.net',
    dynamicLinkInfo: {
      domainUriPrefix: 'https://howfmfrodo.page.link',
      iosBundleId: 'com.soundreply.soundreply.develop',
      iosAppStoreId: '',
      androidPackageName: 'fm.how.app.develop',
    },
  },
  [WebAppEnvironment.MERRY]: {
    apiKey: 'AIzaSyCy_F5FiGtZXj5A6SemIpjDZQ9BC53bm7E',
    authDomain: 'howfm-merry.firebaseapp.com',
    projectId: 'howfm-merry',
    storageBucket: 'howfm-merry.appspot.com',
    messagingSenderId: '934656511451',
    appId: '1:934656511451:web:abcdef123789',
    databaseURL: 'https://howfm-merry.firebaseio.com',
    functionsBaseUrl: 'https://us-central1-howfm-merry.cloudfunctions.net',
    dynamicLinkInfo: {
      domainUriPrefix: 'https://howfmmerry.page.link',
      iosBundleId: 'com.soundreply.soundreply.develop',
      iosAppStoreId: '',
      androidPackageName: 'fm.how.app.develop',
    },
  },
  [WebAppEnvironment.PIPPIN]: {
    apiKey: 'AIzaSyDkN3KJ9CJGB1RFecNhaSkBkhT51YgxKT8',
    authDomain: 'howfm-pippin.firebaseapp.com',
    projectId: 'howfm-pippin',
    storageBucket: 'howfm-pippin.appspot.com',
    messagingSenderId: '1060608544288',
    appId: '1:1060608544288:web:abcdef987654',
    databaseURL: 'https://howfm-pippin.firebaseio.com',
    functionsBaseUrl: 'https://us-central1-howfm-pippin.cloudfunctions.net',
    dynamicLinkInfo: {
      domainUriPrefix: 'https://howfmpippin.page.link',
      iosBundleId: 'com.soundreply.soundreply.develop',
      iosAppStoreId: '',
      androidPackageName: 'fm.how.app.develop',
    },
  },
  [WebAppEnvironment.BILBO]: {
    apiKey: 'AIzaSyAbYs0BpmmpJQQD7Xpi5JRFLvF-L15AdYc',
    authDomain: 'how-fm-bilbo.firebaseapp.com',
    projectId: 'how-fm-bilbo',
    storageBucket: 'how-fm-bilbo.appspot.com',
    messagingSenderId: '910136277435',
    appId: '1:910136277435:web:abcdef876543',
    databaseURL: 'https://how-fm-bilbo.firebaseio.com',
    functionsBaseUrl: 'https://us-central1-how-fm-bilbo.cloudfunctions.net',
    dynamicLinkInfo: {
      domainUriPrefix: 'https://howfmbilbo.page.link',
      iosBundleId: 'com.soundreply.soundreply.develop',
      iosAppStoreId: '',
      androidPackageName: 'fm.how.app.develop',
    },
  },
};

export function getFirebaseConfig(targetEnv?: WebAppEnvironment): FirebaseConfig {
  // Target environment must be explicitly provided or defaults to staging
  // Detection from URL/cookies should be done at the app entry point
  const env = targetEnv ?? WebAppEnvironment.STAGING;
  const config = firebaseConfigs[env];

  // Return staging config as fallback
  return config ?? firebaseConfigs[WebAppEnvironment.STAGING];
}

// Helper function to get the name of the current Firebase configuration
export function currentConfigName(targetEnv?: WebAppEnvironment): string {
  // Target environment must be explicitly provided or defaults to staging
  // Detection from URL/cookies should be done at the app entry point
  const env = targetEnv ?? WebAppEnvironment.STAGING;
  const config = firebaseConfigs[env];

  if (!config) {
    return 'unknown';
  }

  switch (config.projectId) {
    case 'how-fm-production-eu':
      return 'production';
    case 'soundreply-coach-poc-staging':
      return 'staging';
    case 'soundreply-coach-ms':
      return 'samwise';
    case 'howfm-frodo':
      return 'frodo';
    case 'howfm-merry':
      return 'merry';
    case 'howfm-pippin':
      return 'pippin';
    case 'how-fm-bilbo':
      return 'bilbo';
    case undefined:
      return 'unknown';
    default:
      return 'unknown';
  }
}
